import { gql } from "@apollo/client";

//mutations
export const REQUEST_CALLBACK = gql`
	mutation UnitMethods($filters: UnitMethodFilters) {
		unitMethods(filters: $filters) {
			requestCallback
		}
	}
`;
